<script lang="ts">
	import type { IconName } from '$lib/components/icons/types';
	import type { SearchCarResult } from '$lib/components/search/cars/types';
	import type { Result } from '$lib/components/search/types';
	import { SearchCarsStore } from '$houdini';
	import SearchInputWithQuery from '$lib/components/search/SearchInputWithQuery.svelte';
	import * as m from '$paraglide/messages';
	import { onMount } from 'svelte';

	interface Props {
		initialValue?: string;
		icon?: IconName | undefined;
		id?: string;
		onSelect?: (result: SearchCarResult | null) => void;
		onActivate?: () => void;
		onDeactivate?: () => void;
	}

	const {
		initialValue = '',
		icon = undefined,
		id = 'car-search',
		onSelect,
		onActivate,
		onDeactivate,
	}: Props = $props();
	let queryStore: SearchCarsStore | undefined = $state();

	onMount(() => {
		queryStore = new SearchCarsStore();
	});

	function handleSelect(result: Result | null) {
		onSelect?.(result as SearchCarResult);
	}
</script>

<SearchInputWithQuery
	{id}
	{icon}
	{queryStore}
	resultToLabel={searchCar => ({ label: ('fullname' in searchCar && searchCar.fullname) || '' })}
	getStoreResults={results => results?.searchCars.cars ?? []}
	queryToVariables={q => ({ input: { carName: q } })}
	{initialValue}
	onSelect={({ result }) => handleSelect(result)}
	{onActivate}
	{onDeactivate}
	label={m.register_car__vehicle()}
	placeholder={m.register_car__search_placeholder()}
/>
